import { bootstrap } from './bootstrap';

import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { loadableReady } from '@loadable/component';
import { createRoot } from 'react-dom/client';

import App from 'app/shared/pages/App';
import configureStore from 'app/shared/flux/configureStore';
import setupRouting from 'app/client/utils/setupRouting';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';

bootstrap.register();

const history = createBrowserHistory();

const initialState = window.__INITIAL_STATE__;

const store = configureStore(initialState, history);
window.store = store;
window.browserHistory = history;

setupRouting();

const AppRoot = (
  <RpErrorBoundary>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </RpErrorBoundary>
);

loadableReady(() => {
  const container = document.getElementById('app-root');
  const root = createRoot(container);

  root.render(AppRoot);
});
